(ns opengb.i18n
  (:require
   [opengb.i18n.locale :as i18n.locale]
   [opengb.i18n.m1p    :as i18n.m1p])
  #?(:clj  (:require [opengb.i18n.hiccup   :as i18n.hiccup]
                     [opengb.i18n.sort     :as i18n.sort])
     :cljs (:require [opengb.i18n.re-frame :as i18n.re-frame])))

(def default-locale
  "Provides a default locale for situations where user locale isn't available,
  or when the locale needs to be consistent across users."
  i18n.locale/default-locale)

(def prepare-dictionaries
  "Takes in a map of dictionaries by locale and returns the map with the
  dictionaries formatted so they can be passed into m1p translate functions.
  If running in a dev environment it also prints out a validation report."
  i18n.m1p/prepare-dictionaries)

(def translate
  "[dictionaries locale k opts debug?]
  Takes in a map of m1p dictionaries keyed by locale, a locale, the key to
  translate, a map of opts, and a flag to enable debug mode. If successful,
  returns the translated string. Otherwise returns the untranslated key as a
  string. Debug mode returns a map of the :input, an optional :translated-str
  (if successful), and an optional :error (if unsuccessful)."
  i18n.m1p/translate)

#?(:clj
   (do
     (def prepare-translation-config
       "`[req dictionaries]`
       Takes in an http req and dictionaries. Returns a map of prepared
       dictionaries, locale, and a debug? flag."
       i18n.hiccup/prepare-translation-config)

     (def tr
       "`[ctx k]`
       `[ctx k params]`

       Translation function that returns a string. Takes in ctx, a key to
       translate and an optional map of params Uses
       :opengb.i18n/translation-config to get dictionaries, current locale, and
       debug flag from ctx. 

       In normal mode, if translation succeeds the correct string is returned.
       If a :default-str has been provided in the params it will be displayed
       next. Otherwise the translation key as a string is returned. 

       In debug mode, a correctly translated string is returned with ✓
       appended, while a failed translation prints the error to the console and
       returns the error as a string surrounded by ¡¡¡!!!."
       i18n.hiccup/translate-str)

     (def Tr
       "`[ctx k]`
       `[ctx k params]`

       Hiccup component that provides a translated span. Takes in a key to
       translate and an optional map of params Uses
       :opengb.i18n/translation-config to get dictionaries, current locale, and
       debug flag from ctx. 

       In normal mode, if translation succeeds the correct string is displayed.
       If a :default-str has been provided in the params it will be displayed
       next. Otherwise the translation key as a string is displayed.

       If :html? has been set to true in params then the translated string will
       be set as the inner html of the span.

       In debug mode, a correctly translated string is returned with ✓
       displayed. A failed translation displays the key as a string in hot pink
       and underlined. The full error is displayed in a hover tooltip."
       i18n.hiccup/TranslatedSpan)

     (def make-locale-comparator
       "`[ctx]`

       Takes in a ctx with a :opengb.i18n/locale and returns a comparator for
       that locale."
       i18n.sort/make-locale-comparator)))

#?(:cljs
   (do
     (def initialize-re-frame
       "Registers re-frame events, subscriptions, and cofx to handle browser
       locale, translation config, and debugging. 

       app-db needs :opengb.i18n/dictionaries to contain a map of locales and
       m1p dictionaries for all of this to function."
       i18n.re-frame/initialize-i18n)

     (def tr
       "`[k]`
       `[k opts]`

       Translation function that returns a string. Takes in a key to translate and an
       optional map of options. Uses :opengb.i18n/translation-config to get
       dictionaries, current locale, and debug flag. 

       In normal mode, if translation succeeds the correct string is returned.
       If a :default-str has been provided in the params it will be displayed next.
       Otherwise the translation key as a string is returned. 

       In debug mode, a correctly translated string is returned with ✓
       appended, while a failed translation prints the error to the console and
       returns the error as a string surrounded by ¡¡¡!!!."
       i18n.re-frame/translate-rf)

     (def Tr
       "`[k]`
       `[k opts]`

       Reagent component that provides a translated span. Takes in a key to
       translate and an optional map of options. Uses
       :opengb.i18n/translation-config to get dictionaries, current locale, and
       debug flag. 

       In normal mode, if translation succeeds the correct string is displayed.
       If a :default-str has been provided in the params it will be displayed next.
       Otherwise the translation key as a string is displayed. 

       If :html? has been set to true in params then the translated string will be
       set as the inner html of the span.

       In debug mode, a correctly translated string is returned with ✓
       displayed. A failed translation displays the key as a string in hot pink
       and underlined. The full error is displayed in a hover tooltip."
       i18n.re-frame/TranslatedSpan)

     (def make-locale-comparator
       "`[]`
       
       Gets current :opengb.i18n/locale and returns a comparator for that locale."
       i18n.re-frame/make-locale-comparator)))
